import type { WorkflowDefinition } from '../../api/workflowRuns'
import { WorkflowSystemTemplateCard } from './WorkflowSystemTemplateCard'

type Props = {
  definitions: WorkflowDefinition[]
  angular: boolean
  busyDefinitionId?: string | null
  onRun?: (definition: WorkflowDefinition) => void
  onOpenBuilder: (definition: WorkflowDefinition) => void
  onQuickSimulate?: (definition: WorkflowDefinition) => void
  onClone?: (definition: WorkflowDefinition) => void
}

export function WorkflowSystemTemplateSection({
  definitions,
  angular,
  busyDefinitionId,
  onRun,
  onOpenBuilder,
  onQuickSimulate,
  onClone,
}: Props) {
  if (definitions.length === 0) return null

  return (
    <section className="mb-8">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <div>
          <h2 className="text-sm font-bold text-ink">系统模板</h2>
          <p className="mt-0.5 text-xs text-ink-soft">可直接编排查看，或一键本地模拟测试（不调用真实模型）</p>
        </div>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {definitions.map((definition) => (
          <WorkflowSystemTemplateCard
            key={definition.publicId}
            definition={definition}
            angular={angular}
            busy={busyDefinitionId === definition.publicId}
            onRun={onRun}
            onOpenBuilder={onOpenBuilder}
            onQuickSimulate={onQuickSimulate}
            onClone={onClone}
          />
        ))}
      </div>
    </section>
  )
}
